import apiShared from "../api/SharedAPI"

const isEmailUnique = async (params) => {
    const result = await apiShared.isEmailUnique(params);
    return result;
}

const isClientEmailUnique = async (params) => {
    const result = await apiShared.isClientEmailUnique(params);
    return result;
}

const isMobileUnique = async (params) => {
    const result = await apiShared.isMobileUnique(params)
    return result
}

const isIdentityUnique = async (params) => {
    const result = await apiShared.isIdentityUnique(params)
    return result
}

const getEmailByRole = async (params) => {
    const result = await apiShared.getEmailByRole(params)
    return result
}

const getMobileByRole = async (params) => {
    const result = await apiShared.getMobileByRole(params)
    return result
}

const getCurrentVersion = async (params) => {
    const result = await apiShared.getCurrentVersion(params);
    return result;
}

const getNewId = async () => {
    const result = await apiShared.getNewId();
    return result
}

const getStateAreas = async () => {
    const result = await apiShared.getStateAreas();
    return result
}

const getICData = async (params) => {
    const result = await apiShared.getICData(params);
    return result
}

export default {
    isEmailUnique: isEmailUnique,
    isClientEmailUnique: isClientEmailUnique,
    isMobileUnique: isMobileUnique,
    isIdentityUnique: isIdentityUnique,
    getCurrentVersion: getCurrentVersion,
    getNewId: getNewId,
    getStateAreas: getStateAreas,
    getICData: getICData,
    getEmailByRole: getEmailByRole,
    getMobileByRole: getMobileByRole
}